import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';
import { INommable } from '../nommable.interface';
import { UserEvent } from './user-event.model';

export class PointageRondeEvent extends UserEvent {
  public static readonly NAME = 'POINTAGE_RONDE_EVENT';

  constructor(
    instant: dayjs.Dayjs,
    public pointeauId: string | undefined,
    public tourneeId?: string,
    coordinates?: Coordinates,
    public idVacation?: string,
    public siteId?: string,
    public zoneId?: string,
    public site?: INommable
  ) {
    super(PointageRondeEvent.NAME, instant, coordinates);
  }

  public static hydrate(obj: PointageRondeEvent): PointageRondeEvent {
    return new PointageRondeEvent(
      dayjs(obj.instant),
      obj.pointeauId,
      obj.tourneeId,
      obj.coordinates,
      obj.idVacation,
      obj.siteId,
      obj.zoneId,
      obj.site
    );
  }
}
